var _rect, _rect2, _path, _path2, _circle, _circle2, _path3, _path4, _circle3, _circle4, _rect3, _circle5, _circle6, _circle7, _path5, _circle8, _circle9, _rect4, _path6, _circle10, _circle11, _circle12, _path7, _path8, _path9, _path10, _path11, _path12, _circle13, _ellipse, _ellipse2, _ellipse3, _path13, _path14, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _path15, _circle20, _circle21, _circle22, _circle23, _circle24, _circle25, _circle26, _circle27, _circle28, _circle29, _circle30;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWeddingpageimg7(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    width: 1072,
    height: 760.00696,
    viewBox: "0 0 1072 760.00696",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "decorative_friends") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 92,
    width: 888,
    height: 672.64865,
    fill: "#d0cde1"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 184,
    y: 42.41928,
    width: 704,
    height: 587.81008,
    fill: "#eae6fc"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M975.4447,413.94246h-332.475a20.303,20.303,0,0,1-20.303-20.303V137.60587a20.30306,20.30306,0,0,0-20.303-20.30305h-4.72724a20.30306,20.30306,0,0,0-20.303,20.30305V393.63942a20.303,20.303,0,0,1-20.303,20.303H224.5553a20.303,20.303,0,0,0-20.303,20.30305v4.72724a20.303,20.303,0,0,0,20.303,20.303h332.475a20.303,20.303,0,0,1,20.303,20.303V722.61239a20.303,20.303,0,0,0,20.303,20.303h4.72724a20.303,20.303,0,0,0,20.303-20.303V479.57884a20.303,20.303,0,0,1,20.303-20.303h332.475a20.303,20.303,0,0,0,20.303-20.303v-4.72724A20.303,20.303,0,0,0,975.4447,413.94246Z",
    transform: "translate(-64 -95.99652)",
    fill: "#d0cde1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M540.628,709.9982l-42.22439-88.993a6.25041,6.25041,0,0,1,5.647-8.92974h0a6.2504,6.2504,0,0,0,5.647-8.92973l-35.2658-74.327a6.25041,6.25041,0,0,1,5.647-8.92974h11.9629a6.2504,6.2504,0,0,0,5.647-8.92973l-37.63-79.30975a6.25041,6.25041,0,0,1,5.647-8.92974h3.95257a6.2504,6.2504,0,0,0,5.647-8.92973L424.92629,307.61a6.2504,6.2504,0,0,0-11.294,0L363.25319,413.79a6.2504,6.2504,0,0,0,5.647,8.92973h3.95257a6.25041,6.25041,0,0,1,5.647,8.92974l-37.63,79.30975a6.2504,6.2504,0,0,0,5.647,8.92973h11.9629a6.25041,6.25041,0,0,1,5.647,8.92974l-35.2658,74.327a6.2504,6.2504,0,0,0,5.647,8.92973h0a6.25041,6.25041,0,0,1,5.647,8.92974l-42.22439,88.993a6.2504,6.2504,0,0,0,5.647,8.92973h83.62431a6.2504,6.2504,0,0,1,6.2504,6.25041V753.1837a6.25041,6.25041,0,0,0,6.25041,6.25041h29.97023a6.25041,6.25041,0,0,0,6.25041-6.25041V725.17834a6.2504,6.2504,0,0,1,6.2504-6.25041H534.981A6.2504,6.2504,0,0,0,540.628,709.9982Z",
    transform: "translate(-64 -95.99652)",
    fill: "#d0cde1"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 808.20989,
    cy: 469.35337,
    r: 58.01086,
    fill: "#fff"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 814.46476,
    cy: 590.62823,
    r: 79.66824,
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M923.52507,606.0756l-95.85092,4.9436a2.67366,2.67366,0,0,0-2.53239,2.80782l.28233,5.47406a2.67367,2.67367,0,0,0,2.80782,2.53244l16.29083-.84021,1.7683,1.52224-10.93386,74.71362,10.1954,12.00472,11.07129-77.82322,49.86383,42.92568,13.78461-3.03447L861.06147,620.1403l63.02135-3.25038a2.67367,2.67367,0,0,0,2.53239-2.80787l-.28233-5.47406A2.67365,2.67365,0,0,0,923.52507,606.0756Z",
    transform: "translate(-64 -95.99652)",
    fill: "#3f3d56"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M839.31334,538.38983s24.18015-13.69024,23.95156-18.12242S852.59972,503.04159,834.871,503.956c0,0-4.84365-7.74933-9.84224-1.27s3.20793,10.50008,3.20793,10.50008-8.92786,16.45876,5.758,25.47806Z",
    transform: "translate(-64 -95.99652)",
    fill: "#3f3d56"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 785.98366,
    cy: 458.88211,
    r: 4.64087,
    fill: "#3f3d56"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 829.24093,
    cy: 456.65108,
    r: 4.64087,
    fill: "#3f3d56"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 868.55336,
    y: 563.78753,
    width: 8.50826,
    height: 26.29825,
    transform: "translate(-92.55801 -50.27456) rotate(-2.95247)",
    fill: "#ff6584"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 814.53559,
    cy: 561.96785,
    r: 4.64087,
    fill: "#3f3d56"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 815.41207,
    cy: 578.96178,
    r: 4.64087,
    fill: "#3f3d56"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 816.28854,
    cy: 595.95571,
    r: 4.64087,
    fill: "#3f3d56"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M873.98246,599.71793a46.19651,46.19651,0,0,1-22.29735-4.745l.66077-1.39854c14.499,6.85015,28.80671,6.11222,42.52594-2.19332l.8019,1.32311A46.20026,46.20026,0,0,1,873.98246,599.71793Z",
    transform: "translate(-64 -95.99652)",
    fill: "#3f3d56"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 842.31727,
    cy: 469.91776,
    r: 3.86739,
    fill: "#ff6584"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 774.34155,
    cy: 473.42368,
    r: 3.86739,
    fill: "#ff6584"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    y: 668.57699,
    width: 1072,
    height: 3.58569,
    fill: "#3f3d56"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M358.15229,384.81895a1.5009,1.5009,0,0,0,0-3,1.5009,1.5009,0,0,0,0,3Z",
    transform: "translate(-64 -95.99652)",
    fill: "#d0cde1"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 658.52252,
    cy: 84.54054,
    r: 11.02703,
    fill: "#d0cde1"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 669.54955,
    cy: 164.18018,
    r: 7.35135,
    fill: "#d0cde1"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 800.64865,
    cy: 262.1982,
    r: 7.35135,
    fill: "#d0cde1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M560.99137,763.54908H250.34458v-.0001A101.69975,101.69975,0,0,1,352.04431,661.84924c56.60219-17.64263,130.43705-11.98228,208.94706,0Z",
    transform: "translate(-64 -95.99652)",
    fill: "#ff6584"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M452.61325,645.36351h146.078a9.24543,9.24543,0,0,1,9.24543,9.24543v0a9.24543,9.24543,0,0,1-9.24543,9.24543h-146.078a0,0,0,0,1,0,0V645.36351A0,0,0,0,1,452.61325,645.36351Z",
    fill: "#3f3d56"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M541.91319,574.8077,581.06775,527.345a10.278,10.278,0,0,1,19.15734,1.64167l15.44073,54.51591Z",
    transform: "translate(-64 -95.99652)",
    fill: "#3f3d56"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M494.4242,598.98025l14.7927-59.72408a10.278,10.278,0,0,1,17.9849-6.80017l37.48774,42.4861Z",
    transform: "translate(-64 -95.99652)",
    fill: "#ff6584"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M186.34458,667.55256H215.93a0,0,0,0,1,0,0v62.869A29.58538,29.58538,0,0,1,186.34461,760.007h0a0,0,0,0,1,0,0v-92.4544A0,0,0,0,1,186.34458,667.55256Z",
    fill: "#ff6584"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M447.066,649.06168H593.144a9.24543,9.24543,0,0,1,9.24543,9.24543v0a9.24543,9.24543,0,0,1-9.24543,9.24543H447.066a0,0,0,0,1,0,0V649.06168A0,0,0,0,1,447.066,649.06168Z",
    fill: "#ff6584"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 496.99137,
    cy: 567.70181,
    r: 99.85075,
    fill: "#ff6584"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 593.14394,
    cy: 575.09816,
    rx: 11.09453,
    ry: 25.88723,
    fill: "#3f3d56"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 566.33217,
    cy: 548.28639,
    rx: 2.77363,
    ry: 6.47181,
    fill: "#3f3d56"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 586.67214,
    cy: 535.34277,
    rx: 2.77363,
    ry: 6.47181,
    fill: "#3f3d56"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M552.61412,562.73622s-5.54972-9.654-5.54972-15.54318",
    transform: "translate(-64 -95.99652)",
    fill: "#3f3d56"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M555.05546,556.49228s3.024-10.717,7.23529-14.83376",
    transform: "translate(-64 -95.99652)",
    fill: "#3f3d56"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 611.22788,
    cy: 388.69156,
    r: 7.58197,
    fill: "#d0cde1"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 588.68468,
    cy: 253.62162,
    r: 7.35135,
    fill: "#d0cde1"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 279.92793,
    cy: 176.43243,
    r: 7.35135,
    fill: "#d0cde1"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 676.80223,
    cy: 425.51156,
    r: 7.35135,
    fill: "#d0cde1"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 256.64865,
    cy: 452.10811,
    r: 7.35135,
    fill: "#d0cde1"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 430.63063,
    cy: 210.73874,
    r: 11.02703,
    fill: "#d0cde1"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M982.98333,343.40544C866.76575,286.19074,809.68488,173.51352,790.538,127.72455a16.51184,16.51184,0,0,0-11.30033-9.72585,16.7313,16.7313,0,0,0-14.75409,3.27494c-69.00763,55.97367-139.74383,77.20454-210.24047,63.10554-58.228-11.645-101.65636-45.08494-122.3609-63.98107a13.36259,13.36259,0,0,0-21.38045,4.81738c-19.01308,46.32317-75.92694,160.31565-193.48452,218.19l-1.0178-2.06595c116.85187-57.52735,173.45815-170.91759,192.37114-216.999a15.66682,15.66682,0,0,1,25.06475-5.644c46.768,42.68554,172.50727,128.209,329.59747.78781A19.02145,19.02145,0,0,1,779.8,115.76518a18.79731,18.79731,0,0,1,12.86358,11.07091C811.71035,172.38551,868.482,284.46892,984,341.33949Z",
    transform: "translate(-64 -95.99652)",
    fill: "#3f3d56"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 187.0571,
    cy: 226.79829,
    r: 19.57765,
    fill: "#3f3d56"
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 266.51934,
    cy: 166.91371,
    r: 19.57765,
    fill: "#3f3d56"
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: 328.70718,
    cy: 67.87381,
    r: 19.57765,
    fill: "#3f3d56"
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: 447.32473,
    cy: 71.32869,
    r: 19.57765,
    fill: "#3f3d56"
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: 538.30324,
    cy: 90.90635,
    r: 19.57765,
    fill: "#3f3d56"
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    cx: 646.55614,
    cy: 59.81243,
    r: 19.57765,
    fill: "#3f3d56"
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    cx: 750.20254,
    cy: 77.08683,
    r: 19.57765,
    fill: "#3f3d56"
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    cx: 804.329,
    cy: 155.39744,
    r: 19.57765,
    fill: "#3f3d56"
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    cx: 867.66846,
    cy: 216.43365,
    r: 19.57765,
    fill: "#3f3d56"
  })), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    cx: 366,
    cy: 25.72973,
    r: 11.02703,
    fill: "#3f3d56"
  })), _circle30 || (_circle30 = /*#__PURE__*/React.createElement("circle", {
    cx: 706,
    cy: 25.72973,
    r: 11.02703,
    fill: "#3f3d56"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeddingpageimg7);
export default __webpack_public_path__ + "static/media/weddingpageimg7.85bbef6fdf8a6302fcb0e695d65c21d7.svg";
export { ForwardRef as ReactComponent };